import React from "react";
import { format } from "date-fns";
import Page from "../../components/Page";
import PhotoSwipeGallery from "../../components/PhotoSwipeGallery";

import {
  getAllGalleries,
  getGallery,
  getAcfGallery,
} from "../../data/galleries";

export default function Home(props) {
  const article = props.page.fullArticle;
  console.log(article.acf.gallery);
  if (article.embedded) {
    var image = article._embedded["wp:featuredmedia"][0];
  } else {
    var image = "/public-next/images/quell-placeholder.png";
  }
  var gallery = article.acf.gallery ? article.acf.gallery : [];

  return (
    <div id="page" className="site gallery-layout">
      <Page
        title={
          article.title.rendered.replace(
            /&#8217;/g,
            "'"
          ) /*removes wordpress html code for an apostrophe and replaces it with an actual one*/
        }
        body={article.excerpt.rendered}
        heroBody={props.page.acf.hero.body}
        hideDate={props.page.acf.hero.hideDate}
        bgImage={props.page.acf.hero.bgImage}
        bgId={image.id}
        alt={image.alt}
        height={image.height}
        width={image.width}
        slug={"/" + article.slug}
        bottomLeft
        disableArrow
        gallery={gallery}
      >
        <main id="content" className="single-story">
          <div className="container">
            {/* Check if the content contains gallery HTML */}
            {props.page.fullArticle.content.rendered.includes(
              'class="gallery'
            ) ||
            props.page.fullArticle.content.rendered.includes(
              "class='gallery"
            ) ? (
              <PhotoSwipeGallery
                galleryHtml={props.page.fullArticle.content.rendered}
                galleryId="main-gallery"
              />
            ) : (
              <div
                dangerouslySetInnerHTML={{
                  __html: props.page.fullArticle.content.rendered,
                }}
              />
            )}
          </div>
        </main>
      </Page>
      <style jsx>{`
        @media (min-width: 960px) {
          .container {
            padding: 5rem 20rem;
          }
        }

        p,
        p *,
        ul *,
        li,
        li * {
          color: #3a434f;
          font-family: Europa, sans-serif;
        }
      `}</style>
    </div>
  );
}

///wp-json/wp/v2/posts?slug=post-slug

export async function getStaticProps({ context, params }) {
  let fullArticle = await getGallery(params.slug);
  let fullAcfGallery = await getAcfGallery(params.id);
  const page = {
    acf: {
      hero: {
        title: fullArticle.title.rendered,
        body: "&nbsp;",
        bgImage: fullArticle._embedded["wp:featuredmedia"]
          ? fullArticle._embedded["wp:featuredmedia"][0].source_url
          : "/public-next/images/quell-placeholder.png",
      },
    },
    fullArticle,
    fullAcfGallery,
  };

  return {
    props: {
      page,
    },
  };
}

export async function getStaticPaths(context) {
  const galleries = await getAllGalleries();
  const paths = galleries.map((gallery) => ({
    params: gallery,
  }));

  return {
    paths,
    fallback: false,
  };
}
